/** True when a rich-text HTML value carries no visible content — TipTap leaves
 *  behind markup (`<p></p>`) for a description the user emptied out. */
function isEmptyRichText(html: string): boolean {
  return html.replace(/<[^>]*>/g, "").trim() === "";
}

/**
 * Storage form of a rich-text value: visually-empty markup persists as "".
 *
 * INVARIANT: this is the *persisted* form only — never feed it back to
 * `RichTextEditor` as its `value`. Keep the raw editor buffer in local state and
 * normalize on the way out (see `WorkitemDescription` for why).
 */
export function normalizeRichText(html: string): string {
  return isEmptyRichText(html) ? "" : html;
}
